import { ScreenLocationOption } from "../modals/CreateRuleModal";

export function normalizeLocationPreviewImageUrl(location: ScreenLocationOption): string | undefined {
	const raw = location.previewUrl;
	if (!raw || typeof raw !== "string") return undefined;
	const trimmed = raw.trim().replace(/\r/g, "");
	return trimmed || undefined;
}